export default __webpack_public_path__ + "static/logowhite-baaf9066e6cf05bbd2dcfef0332efecf.png";